
export enum AdnetNetworkPropSelector {
    CONTENT, PACKAGE, RESOURCE, TARGET, PAIR, NONE, PACKAGE_VIEW
}

export enum AdnetPackagePlayMode {
    TIME, LOCATION, ASSETS
}

export interface IAdNetworkPropSelectedEvent {
    selected: AdnetNetworkPropSelector
}

export type TabType = "packagesTab" | "targetsTab";
